import { render } from "./LayoutContainer.vue?vue&type=template&id=44b70c38&scoped=true"
import script from "./LayoutContainer.vue?vue&type=script&lang=js"
export * from "./LayoutContainer.vue?vue&type=script&lang=js"

import "./LayoutContainer.vue?vue&type=style&index=0&id=44b70c38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b70c38"]])

export default __exports__